import React from "react"
import { Typography } from "@material-ui/core"

export default function Text(props) {
    const { title } = props
    return <Typography>
        {title}
    </Typography>
}